import BasePriceBinder from './BasePriceBinder';

export default class RadioBinder extends BasePriceBinder {
	optionValue;
	optionLabel;

	constructor(
		id,
		title,
		calculator,
		summaryDisplayer,
		priceFormatter,
		optionLabel,
		optionValue
	) {
		super(
			id,
			`${title} (${optionLabel})`,
			calculator,
			summaryDisplayer,
			priceFormatter
		);
		this.optionLabel = optionLabel;
		this.optionValue = optionValue;
		this.optionId = `${this.id}_${optionValue}`;
		this.baseElement = document.getElementsByName(this.id);
		this.isActive = this.getActiveState();
	}

	getActiveState() {
		const checkedRadio = Array.from(this.baseElement).find(
			(radio) => radio.checked
		);
		return checkedRadio ? checkedRadio.value === this.optionValue : false;
	}

	initEvents() {
		this.baseElement.forEach((element) => {
			element.addEventListener('change', (e) => {
				this.isActive = this.getActiveState();
				this.handleChange();
			});
		});

		super.initEvents();
	}
}
